module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/$.add-to-unscopables.js
// module id = 316
// module chunks = 0